import React, { useEffect, useState } from 'react';
import './styles/DarkTheme.css';

import './styles/App.css';
import Typewriter from './Typewriter';
import JourneySection from './JourneySection'
import ContactsSection from './ContactsSection';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin, withAITracking } from '@microsoft/applicationinsights-react-js';
import { createBrowserHistory } from "history";

if (process.env.REACT_APP_CONNECTION_STRING) {
  const browserHistory = createBrowserHistory({ basename: '' });
  var reactPlugin = new ReactPlugin();
  var appInsights = new ApplicationInsights({
      config: {
          connectionString: process.env.REACT_APP_CONNECTION_STRING,
          extensions: [reactPlugin],
          extensionConfig: {
            [reactPlugin.identifier]: { history: browserHistory }
          }
      }
  });
  appInsights.loadAppInsights();
}

function SystemBar() {
  const [time, setTime] = useState(() => new Date());

  useEffect(() => {
    const id = setInterval(() => setTime(new Date()), 1000);
    return () => clearInterval(id);
  }, []);

  const hh = String(time.getUTCHours()).padStart(2, '0');
  const mm = String(time.getUTCMinutes()).padStart(2, '0');
  const ss = String(time.getUTCSeconds()).padStart(2, '0');

  return (
    <div className="system-bar" aria-hidden="true">
      <div className="left">
        <span className="pill"><span className="ind"></span>SYS <span className="accent">ONLINE</span></span>
        <span className="hide-sm">NODE//DMR-01</span>
        <span className="hide-sm">v2026.05</span>
      </div>
      <div className="right">
        <span className="hide-sm">LAT 47.61° N</span>
        <span className="hide-sm">LON 122.33° W</span>
        <span className="pill amber"><span className="ind"></span>UTC {hh}:{mm}:{ss}</span>
      </div>
    </div>
  );
}

function App() {
  return (
    <div id="mainAppDiv">
    <SystemBar />
    <div className="App">

      <section id="introSection">
      <div className="backgroundimage">
          <Typewriter />
      </div>
      </section>

      <JourneySection />

      <ContactsSection/>

    </div>
    </div>
  );
}

export default withAITracking(reactPlugin, App);
